module.exports = __webpack_public_path__ + "static/img/1.ea8c252.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/zh/1.png
// module id = SlHd
// module chunks = 0